import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { serializer } from './serializer';

bus.on(constants.EVENTS.LEADERBOARD.LIST_ALL.REFRESH, () => {
  const requestId = `listAllAds-${Date.now()}`;
  bus.emit(constants.EVENTS.LEADERBOARD.LIST_ALL.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: `${constants.ENDPOINTS.LEADERBOARD.GET_LIST}`,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(constants.EVENTS.LEADERBOARD.LIST_ALL.REFRESHED, parsed.data);
      } else {
        bus.emit(constants.EVENTS.LEADERBOARD.LIST_ALL.REFRESH_ERROR, parsed);
      }
    }
  });
});
